import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m16 20.867-.939 1.726-.359-1.932-1.426 1.352.255-1.949-1.774.845.845-1.774-1.948.256 1.351-1.426-1.931-.36 1.726-.938-1.726-.939 1.931-.36-1.351-1.425 1.948.255-.845-1.774 1.774.845-.255-1.948 1.426 1.351.36-1.931.938 1.726.939-1.726.359 1.931 1.426-1.351-.255 1.948 1.773-.845-.844 1.774 1.948-.255-1.352 1.426 1.932.36-1.726.938 1.726.938-1.932.36 1.352 1.426-1.948-.256.845 1.774-1.774-.844.255 1.948-1.426-1.352-.36 1.932zm3.902-13.901a9 9 0 0 0-1.466.39c.292-.036.548-.073.85-.032.151.021.328.162.316.233l-1.707-.01c-.674.241-1.295.456-1.882.453-.836-.005-1.712-.35-2.163-.849l-.972-.007c-.198-.01-.442-.275-.308-.339l.943-.025c.33-.236.815-.285 1.454.097l.373-.018c-.723-.477-1.636-.659-2.573-.784-.885-.118-2.159-.379-2.767-.9 1.406.352 3.523.46 4.443.567.69.08 1.28.324 1.54.857.673-.584 1.149-1.242 3.08-1.248C20.387 5.346 21.688 5.162 23 5c-1.035.51-3.206 1.172-5 1.263-.164.008-.44.341-.746.655z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.029 18h31.937a33 33 0 0 1-.833 6.124s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124.35 22.056.106 19.97.03 18",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M3.754 30.333c-1.251 0-2.503-.572-3.754-1.01v-2.5c1.251.438 2.503 1.01 3.754 1.01 2.026 0 4.053-1.5 6.079-1.5s4.052 1.5 6.078 1.5 4.052-1.5 6.079-1.5c2.026 0 4.052 1.5 6.078 1.5 1.31 0 2.621-.627 3.932-1.07v2.5c-1.31.443-2.621 1.07-3.932 1.07-2.026 0-4.052-1.5-6.079-1.5-2.026 0-4.052 1.5-6.078 1.5s-4.052-1.5-6.078-1.5-4.053 1.5-6.079 1.5m0-10.333C2.503 20 1.251 19.428 0 18.99v-2.5c1.251.438 2.503 1.01 3.754 1.01 2.026 0 4.053-1.5 6.079-1.5s4.052 1.5 6.078 1.5S19.963 16 21.99 16c2.026 0 4.052 1.5 6.078 1.5 1.31 0 2.621-.628 3.932-1.071v2.5C30.69 19.372 29.379 20 28.068 20c-2.026 0-4.052-1.5-6.079-1.5-2.026 0-4.052 1.5-6.078 1.5s-4.052-1.5-6.078-1.5S5.78 20 3.754 20M.915 24.324a27 27 0 0 1-.547-2.702c1.129.412 2.257.878 3.386.878 2.026 0 4.053-1.5 6.079-1.5s4.052 1.5 6.078 1.5S19.963 21 21.99 21c2.026 0 4.052 1.5 6.078 1.5 1.186 0 2.372-.514 3.559-.94-.127.85-.29 1.709-.494 2.564l-.03.128c-1.012.374-2.023.748-3.035.748-2.026 0-4.052-1.5-6.079-1.5-2.026 0-4.052 1.5-6.078 1.5s-4.052-1.5-6.078-1.5S5.78 25 3.754 25c-.946 0-1.892-.327-2.839-.676",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagKir = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagKir_default = SvgFlagKir;

export { FlagKir_default as default };
